<template>
  <GestionBodegas />
</template>
<script>
import GestionBodegas from "./components/GestionBodegas";
export default {
  components: { GestionBodegas },
};
</script>
